import { Components, inputLabelClasses, Theme } from '@mui/material';

export function getMuiInputLabel(theme: Theme): Components['MuiInputLabel'] {
  return {
    defaultProps: {
      shrink: true,
    },
    styleOverrides: {
      root: {
        [`&.${inputLabelClasses.focused}, &.${inputLabelClasses.error}`]: {
          color: 'inherit',
        },

        [`&.${inputLabelClasses.disabled}`]: {
          color: theme.palette.grey[400],
        },
      },

      shrink: {
        position: 'static',
        fontSize: 16,
        fontWeight: 700,
        color: theme.palette.common.black,
        transform: 'none',
      },
    },
  };
}
